import { createSelector } from 'reselect';
import { get } from 'lodash';

export const getUnitIdFromRoute = (state, props) => get(props, 'match.params.unitId');
export const getFacilityIdFromRoute = (state, props) => get(props, 'match.params.facilityId');

export const getUnitLookup = createSelector(
	getUnitIdFromRoute,
	(state) => state.units.byId,
	(unitId, units) => get(units, unitId)
);

export const getFacilityLookup = createSelector(
	getFacilityIdFromRoute,
	(state) => state.facilities.byId,
	(facilityId, facilities) => get(facilities, facilityId)
);

export const getUnitFacilityLookup = createSelector(
	getUnitIdFromRoute,
	getUnitLookup,
	getFacilityIdFromRoute,
	getFacilityLookup,
	(state) => state.pageMeta.phone,
	(unitId, unit, facilityId, facility, phone) => ({
		unitId,
		unit,
		facilityId,
		facility,
		phone
	})
);
